import { Component, OnInit } from '@angular/core';
import { EntitiesService, GenesisUnitOfWork } from 'app/core/core.module';
import { OrderLineDetail } from 'app/core/model/order-line-detail';
import _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-allocate-dialog',
    templateUrl: './allocate-dialog.component.html',
    styleUrls: ['./allocate-dialog.component.scss'],
    standalone: false
})
export class AllocateDialogComponent implements OnInit {
    result = new Subject<{ success: boolean; value?: number }>();
    orderLineDetailId: number;
    orderLineDetail: OrderLineDetail;
    matchingOrders: OrderLineDetail[] = [];
    selectedMatchingOrder: OrderLineDetail;
    matchingOptions: string[] = [];
    missingOptions: string[] = [];
    additionalOptions: string[] = [];
    total: number = 0;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private entitiesService: EntitiesService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        const expand = ['packingSlip', 'orderLine.order.achPayments', 'orderLine.order.pricingTier', 'orderLine.order.confirmations', 'optionDetails.orderLine', 'notes'];
        this.orderLineDetail = await this.uow.getOrderBuildDetailById(this.orderLineDetailId, expand);
        this.entitiesService.setNoteHtml([this.orderLineDetail]);
        this.entitiesService.setOptionHtml([this.orderLineDetail]);
        this.matchingOrders = await this.uow.getMatchingOrderLineDetails(this.orderLineDetailId, expand);
        this.entitiesService.setNoteHtml(this.matchingOrders);
        this.entitiesService.setOptionHtml(this.matchingOrders);
        this.getTotal();
    }

    getTotal() {
        this.total = (this.orderLineDetail.price * this.orderLineDetail.quantity);
        this.orderLineDetail.optionDetails.forEach(option => {
            if (!option.deleted) this.total += (option.price * option.quantity)
        });
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarTextBefore',
                location: 'before',
            },
            {
                template: 'toolbarTextAfter',
                location: 'after',
            }
        );
    }

    selectionChange(matchingOrder: OrderLineDetail) {
        this.matchingOptions = [];
        this.missingOptions = [];
        this.additionalOptions = [];
        this.selectedMatchingOrder = matchingOrder;
        if (!matchingOrder) return;

        const options = _(this.orderLineDetail.optionDetails.filter((option) => !option.deleted))
            .sortBy('orderLine.partNumber')
            .valueOf();
        const matchingOptions = _(matchingOrder.optionDetails.filter((option) => !option.deleted))
            .sortBy('orderLine.partNumber')
            .valueOf();
        options.forEach((option) => {
            const matchingOption = matchingOptions.find((matchingOption) => matchingOption.orderLine.partId === option.orderLine.partId);
            if (matchingOption) this.matchingOptions.push(option.orderLine.partNumber);
            else this.missingOptions.push(option.orderLine.partNumber);
        });

        matchingOptions
            .filter((matchingOption) => !options.some((option) => option.orderLine.partId === matchingOption.orderLine.partId))
            .forEach((matchingOption) => this.additionalOptions.push(matchingOption.orderLine.partNumber));
    }

    async save() {
        this.orderLineDetail.notes.forEach(x => x.preAllocationNote = true);
        this.result.next({ success: true, value: this.selectedMatchingOrder.id });
        this.modalRef.hide();
    }

    cancel() {
        this.result.next({ success: false });
        this.modalRef.hide();
    }
}
